import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue';
import { UserProfileBare } from 'SharedDir/declarations/user-profiles';
import { useAuthStore } from 'SharedDir/stores/auth.store';
import { useUserStore } from 'SharedDir/stores/user.store';
import { useAppStore } from 'stores/app';
import ProfilePicker from 'components/Auth/ProfilePicker.vue';
import PortalDialog from 'components/base/PortalDialog.vue';
import { checkCurrentProfile } from 'boot/middleware';


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'ProfileDialog' },
  __name: 'ProfileDialog',
  setup(__props) {


const [appStore, authStore, userStore] = [useAppStore(), useAuthStore(), useUserStore()];
const currentProfile = computed({
  get() {
    return userStore.currentProfile;
  },

  set(profile: UserProfileBare | null) {
    console.debug(profile);
    userStore.changeProfile(profile);
  },
});
const show = computed({
  get() {
    return (
      appStore.profileDialogShow || (authStore.isAuthenticated && currentProfile.value === null)
    );
  },

  set(value: boolean) {
    appStore.setProfileDialog(value);
  },
});

const forceToPick = computed(() => !checkCurrentProfile(userStore));

async function logout() {
  await authStore.logout();
  appStore.hideProfileDialog();
}

function close() {
  setTimeout(() => {
    show.value = false;
  }, 300);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PortalDialog, {
    modelValue: show.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((show).value = $event)),
    title: "Выберите профиль",
    persistent: forceToPick.value,
    pattern: "",
    info: ""
  }, {
    default: _withCtx(() => [
      _createVNode(ProfilePicker, {
        modelValue: currentProfile.value,
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = ($event: any) => ((currentProfile).value = $event)),
          close
        ]
      }, null, 8, ["modelValue"]),
      _createElementVNode("div", { class: "text-center" }, [
        _createElementVNode("span", {
          class: "s-link",
          onClick: logout
        }, "Выйти из системы")
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "persistent"]))
}
}

})